import React from "react"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import { BLOCKS, INLINES } from "@contentful/rich-text-types"
import { encryptUserInfo } from "../../../shared/utils/encryptUserInfo"
import { pushDataLayerEvent } from "../../../shared/utils/metricManagementUtil"

import "./collapse-faq.scss"

const CollapseFaq = props => {
  const { options, activeCollapse, setActiveCollapse } = props

  const LOCALE = process.env.LOCALE ? process.env.LOCALE : "es-CO"

  let options1 = {
    renderNode: {
      [BLOCKS.EMBEDDED_ASSET]: (node, next) => (
        <img
          className="f-aticle-content-img"
          src={
            node.data.target.fields.file[LOCALE]
              ? node.data.target.fields.file[LOCALE].url
              : node.data.target.fields.file["es-CO"].url
          }
          alt={node.data.target.fields.description[LOCALE]}
        />
      ),
      [BLOCKS.EMBEDDED_ASSET]: (node, next) => {
        if (node.data.target.fields) {
          return (
            <img
              className="f-aticle-content-img"
              src={
                node.data.target.fields.file[LOCALE]
                  ? node.data.target.fields.file[LOCALE].url
                  : node.data.target.fields.file["es-CO"].url
              }
              alt={node.data.target.fields.description[LOCALE]}
            />
          )
        } else {
          return null
        }
      },
      [INLINES.HYPERLINK]: (node, next) => {
        return (<a
          href={node.data.uri}
          rel="noopener noreferrer"
          onClick={() => dataLayerLink(node.data.uri)}
        >{next}</a>)
      },
    },
  }

  const userInfoEncrypt = encryptUserInfo()
  const dataLayerLink = (option) => {
    pushDataLayerEvent({
      event: 'Interacciones_Enlaces',
      category: 'link',
      action: 'click',
      label: option,
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }
  const dataLayerFac = (option) => {
    pushDataLayerEvent({
      event: 'Interacciones_Contactanos',
      category: 'contactanos',
      action: 'click',
      label: option,
      sub_category: 'Preguntas frecuentes',
      location: typeof window !== 'undefined' ? window.location.href : '',
      user_data: userInfoEncrypt.user_data ? userInfoEncrypt.user_data : '',
      log_status: userInfoEncrypt.log_status,
    })
  }

  return (
    <div className="f-faq-collapse-container">
      <ul className="f-list-collapse">
        {options.map((option, index) => {
          if (index === 0) {
            return (
              <li
                className="f-item-collapse"
                id="f-mail"
                key={index}
                onClick={() => {
                  if (activeCollapse === index) {
                    setActiveCollapse(-1)
                  } else {
                    dataLayerFac(option.tituloPrincipal)
                    setActiveCollapse(index)
                  }
                }
                }
              >
                <div className="f-collapse-title-container">
                  <h2
                    className={
                      "f-collapse-title " +
                      (activeCollapse === index ? "f-title-pink" : "")
                    }
                  >
                    {option.tituloPrincipal}
                  </h2>
                  {activeCollapse === index ? (
                    <span>
                      <span className="f-icon-less" />
                    </span>
                  ) : (
                    <span className="f-icon icon2-close f-icon-close" />
                  )}
                </div>
                <div
                  className={
                    "f-collapse-description-container " +
                    (activeCollapse === index ? "f-collapse-active" : "")
                  }
                  onClick={e => e.stopPropagation()}
                >
                  <div
                    className={
                      "f-collapse-position-container " +
                      (activeCollapse === index ? "f-active" : "")
                    }
                  >
                    {documentToReactComponents(
                      option.descripcion.json,
                      options1
                    )}
                  </div>
                </div>
              </li>
            )
          } else {
            return (
              <li
                className="f-item-collapse"
                key={index}
                onClick={ () => {
                  if (activeCollapse === index) {
                    setActiveCollapse(-1)
                  } else {
                    dataLayerFac(option.tituloPrincipal)
                    setActiveCollapse(index)
                  }
                }
                }
              >
                <div className="f-collapse-title-container">
                  <h2
                    className={
                      "f-collapse-title " +
                      (activeCollapse === index ? "f-title-pink" : "")
                    }
                  >
                    {option.tituloPrincipal}
                  </h2>
                  {activeCollapse === index ? (
                    <span>
                      <span className="f-icon-less" />
                    </span>
                  ) : (
                    <span className="f-icon icon2-close f-icon-close" />
                  )}
                </div>
                <div
                  className={
                    "f-collapse-description-container " +
                    (activeCollapse === index ? "f-collapse-active" : "")
                  }
                  onClick={e => e.stopPropagation()}
                >
                  <div
                    className={
                      "f-collapse-position-container " +
                      (activeCollapse === index ? "f-active" : "")
                    }
                  >
                    {documentToReactComponents(
                      option.descripcion.json,
                      options1
                    )}
                  </div>
                </div>
              </li>
            )
          }
        })}
      </ul>
    </div>
  )
}

export default CollapseFaq
